/* eslint-disable jsdoc/require-jsdoc */
import type { AxiosInstance } from 'axios';
import axios from 'axios';
import Config from '@/config';
import { app } from '@/store';
import store from '@/app/store/store';

/**
 *
 */
export class Api {
  private static _instance: Api;
  private static _base: AxiosInstance;
  private static _gethelp: AxiosInstance;
  private static _youtube: AxiosInstance;

  private constructor() {
    if (!Api._instance) {
      Api._instance = this;
    }

    return Api._instance;
  }

  public static get base() {
    const _this = this;
    if (!Api._base) {
      const baseUrl = Config.getSetting('baseURL');
      const gemSession = app.$store.getters['app/gemSession'] || '';
      const settings = {
        baseURL: baseUrl,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Gem-Session': gemSession
        },
        withCredentials: true,
      };

      this._base = axios.create(settings);
    }

    store.onChange('gemSession', function (value) {
      _this._base.defaults.headers['Gem-Session'] = value;
    });

    return this._base;
  }
  public static get getHelp() {
    if (!Api._gethelp) {
      // local
      let helpCenterURL = 'https://gem-help.herokuapp.com';

      if (import.meta.env.VITE_APP_MODE == 'production') {
        helpCenterURL = Config.getSetting('helpCenterURL');
      }

      this._gethelp = axios.create({
        paramsSerializer: (params) => {
          let result = '';
          Object.keys(params).forEach((key) => {
            result += `${key}=${encodeURIComponent(params[key])}&`;
          });
          return result.substr(0, result.length - 1);
        },
        baseURL: helpCenterURL,
        headers: {
          'app-name': 'GemPages',
        },
      });
    }
    return this._gethelp;
  }
  public static get youtube() {
    if (!Api._youtube) {
      this._youtube = axios.create({
        baseURL: 'https://www.googleapis.com/youtube/v3',
        headers: {},
      });
    }
    return this._youtube;
  }
  public static createXMLHttpRequest(method: string, url: string, data?: any) {
    return new Promise((resolve, reject): void => {
      const request = new XMLHttpRequest();
      request.overrideMimeType('application/json');
      request.open(method, url, true);
      request.onreadystatechange = (): void => {
        // Request has completed
        if (request.readyState === 4) {
          if ([200, 201].includes(request.status)) {
            // On success
            try {
              resolve(JSON.parse(request.responseText));
            } catch (e) {
              resolve(request.responseText);
            }
          } else {
            reject(new Error(request.responseText));
          }
        }
      };
      request.send(data);
    });
  }
  public static async excuteGraphQL(operation: string, variables: any) {
    return Api.base.post('/graphqlProxy', {
      operation,
      variables,
    });
  }
}
